// These should match the images sizes that get genearted in the initResponsiveImages in responsive-images.ts
// as they get sent to the backend to generate the API json

export const imageFormats = ["WEBP", "JPG"];
export const heroImagesSizes = [640, 768, 1024, 1366, 1632];
export const cmsMasonryImagesSizes = [800];
